const asNumber = value => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value
  }

  const parsed = Number.parseFloat(value)
  return Number.isNaN(parsed) ? Number.MAX_SAFE_INTEGER : parsed
}

const byDirection = (value, direction) => {
  return direction === 'desc' ? -value : value
}

const parseCoach = coachValue => {
  const raw = `${coachValue || ''}`.trim()
  const match = raw.match(/^(\d+)\/(\d+)(?:\s+([DON]))?$/i)

  if (!match) {
    return {
      skill: -1,
      leadership: -1,
      type: '',
    }
  }

  return {
    skill: Number.parseInt(match[1], 10),
    leadership: Number.parseInt(match[2], 10),
    type: (match[3] || '').toUpperCase(),
  }
}

export const sortTeamsByTeamId = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) =>
    byDirection(asNumber(a?.TeamID) - asNumber(b?.TeamID), direction)
  )
}

export const sortTeamsBySeries = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const seriesA = String(a?.series || '')
    const seriesB = String(b?.series || '')

    const bySeriesRaw = seriesA.localeCompare(seriesB, 'fi', {
      numeric: true,
      sensitivity: 'base',
    })

    const bySeries = byDirection(bySeriesRaw, direction)

    if (bySeries !== 0) {
      return bySeries
    }

    return byDirection(asNumber(a?.TeamID) - asNumber(b?.TeamID), direction)
  })
}

export const sortTeamsByFanClub = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const byFanClub = byDirection(asNumber(a?.fanClub) - asNumber(b?.fanClub), direction)

    if (byFanClub !== 0) {
      return byFanClub
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsBySalaryTotal = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const bySalary = byDirection(asNumber(a?.salaryTotal) - asNumber(b?.salaryTotal), direction)

    if (bySalary !== 0) {
      return bySalary
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByTsiTotal = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const byTsi = byDirection(asNumber(a?.tsiTotal) - asNumber(b?.tsiTotal), direction)

    if (byTsi !== 0) {
      return byTsi
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByAvgAge = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const byAge = byDirection(asNumber(a?.avgAge) - asNumber(b?.avgAge), direction)

    if (byAge !== 0) {
      return byAge
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByAvgExperience = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const byExperience = byDirection(
      asNumber(a?.avgExperience) - asNumber(b?.avgExperience),
      direction
    )

    if (byExperience !== 0) {
      return byExperience
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByAvgStamina = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const byStamina = byDirection(
      asNumber(a?.avgStamina) - asNumber(b?.avgStamina),
      direction
    )

    if (byStamina !== 0) {
      return byStamina
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByAvgForm = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const byForm = byDirection(asNumber(a?.avgForm) - asNumber(b?.avgForm), direction)

    if (byForm !== 0) {
      return byForm
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByPowerRating = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const byPowerRating = byDirection(
      asNumber(a?.powerRating) - asNumber(b?.powerRating),
      direction
    )

    if (byPowerRating !== 0) {
      return byPowerRating
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByRemainingCupSeed = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const byRemainingCupSeed = byDirection(
      asNumber(a?.remainingCupSeed) - asNumber(b?.remainingCupSeed),
      direction
    )

    if (byRemainingCupSeed !== 0) {
      return byRemainingCupSeed
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsBySpecialtyCount = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const bySpecialty = byDirection(
      asNumber(a?.specialtyCount) - asNumber(b?.specialtyCount),
      direction
    )

    if (bySpecialty !== 0) {
      return bySpecialty
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByHatstats = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const byHatstats = byDirection(asNumber(a?.hatstats) - asNumber(b?.hatstats), direction)

    if (byHatstats !== 0) {
      return byHatstats
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByYouthTopSalary = ({ teams, direction = 'asc' }) => {
  const toYouthSalary = value => {
    if (typeof value === 'number' && Number.isFinite(value)) {
      return value
    }

    const parsed = Number.parseFloat(value)
    return Number.isNaN(parsed) ? -1 : parsed
  }

  return [...teams].sort((a, b) => {
    const byYouthSalary = byDirection(
      toYouthSalary(a?.youthTopSalary) - toYouthSalary(b?.youthTopSalary),
      direction
    )

    if (byYouthSalary !== 0) {
      return byYouthSalary
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByYouthTeamMode = ({ teams, direction = 'desc' }) => {
  return [...teams].sort((a, b) => {
    const byMode = byDirection(
      asNumber(a?.youthTeamModeSort) - asNumber(b?.youthTeamModeSort),
      direction
    )

    if (byMode !== 0) {
      return byMode
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByArenaCapacity = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const byArena = byDirection(
      asNumber(a?.arenaCapacity) - asNumber(b?.arenaCapacity),
      direction
    )

    if (byArena !== 0) {
      return byArena
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByRank = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const byRank = byDirection(asNumber(a?.rank) - asNumber(b?.rank), direction)

    if (byRank !== 0) {
      return byRank
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByLeaguePosition = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const byPosition = byDirection(
      asNumber(a?.leaguePosition) - asNumber(b?.leaguePosition),
      direction
    )

    if (byPosition !== 0) {
      return byPosition
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByPoints = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const byPoints = byDirection(asNumber(a?.points) - asNumber(b?.points), direction)

    if (byPoints !== 0) {
      return byPoints
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByGoalDiff = ({ teams, direction = 'asc' }) => {
  return [...teams].sort((a, b) => {
    const byGoalDiff = byDirection(asNumber(a?.goalDiff) - asNumber(b?.goalDiff), direction)

    if (byGoalDiff !== 0) {
      return byGoalDiff
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByCup = ({ teams, direction = 'asc' }) => {
  const toCupLevel = team => {
    const cupLevel = Number.parseInt(team?.FemmeTeam?.Cup?.CupLevel, 10)
    return Number.isInteger(cupLevel) ? cupLevel : Number.MAX_SAFE_INTEGER
  }

  const toCupLevelIndex = team => {
    const cupLevel = Number.parseInt(team?.FemmeTeam?.Cup?.CupLevel, 10)

    // CupLevelIndex only affects ordering inside CupLevel 2.
    if (cupLevel !== 2) {
      return 0
    }

    const cupLevelIndex = Number.parseInt(team?.FemmeTeam?.Cup?.CupLevelIndex, 10)
    return Number.isInteger(cupLevelIndex) ? cupLevelIndex : Number.MAX_SAFE_INTEGER
  }

  return [...teams].sort((a, b) => {
    const byCupLevel = byDirection(toCupLevel(a) - toCupLevel(b), direction)

    if (byCupLevel !== 0) {
      return byCupLevel
    }

    const byCupLevelIndex = byDirection(toCupLevelIndex(a) - toCupLevelIndex(b), direction)

    if (byCupLevelIndex !== 0) {
      return byCupLevelIndex
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByCoachSkill = ({ teams }) => {
  return [...teams].sort((a, b) => {
    const coachA = parseCoach(a?.coach)
    const coachB = parseCoach(b?.coach)
    const bySkill = coachB.skill - coachA.skill

    if (bySkill !== 0) {
      return bySkill
    }

    const byLeadership = coachB.leadership - coachA.leadership
    if (byLeadership !== 0) {
      return byLeadership
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByCoachLeadership = ({ teams }) => {
  return [...teams].sort((a, b) => {
    const coachA = parseCoach(a?.coach)
    const coachB = parseCoach(b?.coach)
    const byLeadership = coachB.leadership - coachA.leadership

    if (byLeadership !== 0) {
      return byLeadership
    }

    const bySkill = coachB.skill - coachA.skill
    if (bySkill !== 0) {
      return bySkill
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByCoachType = ({ teams, selectedType }) => {
  const normalizedType = `${selectedType || ''}`.toUpperCase()

  return [...teams].sort((a, b) => {
    const coachA = parseCoach(a?.coach)
    const coachB = parseCoach(b?.coach)
    const typeA = `${a?.coachTypeCode || ''}`.toUpperCase()
    const typeB = `${b?.coachTypeCode || ''}`.toUpperCase()
    const aPriority = typeA === normalizedType ? 1 : 0
    const bPriority = typeB === normalizedType ? 1 : 0
    const byPriority = bPriority - aPriority

    if (byPriority !== 0) {
      return byPriority
    }

    const bySkill = coachB.skill - coachA.skill
    if (bySkill !== 0) {
      return bySkill
    }

    const byLeadership = coachB.leadership - coachA.leadership
    if (byLeadership !== 0) {
      return byLeadership
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamsByCoachTypeOrder = ({ teams, direction = 'desc' }) => {
  const typeOrder = direction === 'desc'
    ? ['D', 'O', 'N']
    : ['N', 'O', 'D']
  const typeRank = new Map(typeOrder.map((type, index) => [type, index]))

  return [...teams].sort((a, b) => {
    const rankA = typeRank.has(a?.coachTypeCode) ? typeRank.get(a.coachTypeCode) : Number.MAX_SAFE_INTEGER
    const rankB = typeRank.has(b?.coachTypeCode) ? typeRank.get(b.coachTypeCode) : Number.MAX_SAFE_INTEGER
    const byType = rankA - rankB

    if (byType !== 0) {
      return byType
    }

    const coachA = parseCoach(a?.coach)
    const coachB = parseCoach(b?.coach)
    const bySkill = coachB.skill - coachA.skill

    if (bySkill !== 0) {
      return bySkill
    }

    return asNumber(a?.TeamID) - asNumber(b?.TeamID)
  })
}

export const sortTeamRows = ({ teams, sortBy, direction = 'asc', coachTypeTop = 'D' }) => {
  if (sortBy === 'series') {
    return sortTeamsBySeries({ teams, direction })
  }

  if (sortBy === 'fanClub') {
    return sortTeamsByFanClub({ teams, direction })
  }

  if (sortBy === 'salaryTotal') {
    return sortTeamsBySalaryTotal({ teams, direction })
  }

  if (sortBy === 'tsiTotal') {
    return sortTeamsByTsiTotal({ teams, direction })
  }

  if (sortBy === 'avgAge') {
    return sortTeamsByAvgAge({ teams, direction })
  }

  if (sortBy === 'avgExperience') {
    return sortTeamsByAvgExperience({ teams, direction })
  }

  if (sortBy === 'avgStamina') {
    return sortTeamsByAvgStamina({ teams, direction })
  }

  if (sortBy === 'avgForm') {
    return sortTeamsByAvgForm({ teams, direction })
  }

  if (sortBy === 'powerRating') {
    return sortTeamsByPowerRating({ teams, direction })
  }

  if (sortBy === 'remainingCupSeed') {
    return sortTeamsByRemainingCupSeed({ teams, direction })
  }

  if (sortBy === 'specialtyCount') {
    return sortTeamsBySpecialtyCount({ teams, direction })
  }

  if (sortBy === 'hatstats') {
    return sortTeamsByHatstats({ teams, direction })
  }

  if (sortBy === 'youthTopSalary') {
    return sortTeamsByYouthTopSalary({ teams, direction })
  }

  if (sortBy === 'youthTeamMode') {
    return sortTeamsByYouthTeamMode({ teams, direction })
  }

  if (sortBy === 'arenaCapacity') {
    return sortTeamsByArenaCapacity({ teams, direction })
  }

  if (sortBy === 'rank') {
    return sortTeamsByRank({ teams, direction })
  }

  if (sortBy === 'leaguePosition') {
    return sortTeamsByLeaguePosition({ teams, direction })
  }

  if (sortBy === 'points') {
    return sortTeamsByPoints({ teams, direction })
  }

  if (sortBy === 'goalDiff') {
    return sortTeamsByGoalDiff({ teams, direction })
  }

  if (sortBy === 'cup') {
    return sortTeamsByCup({ teams, direction })
  }

  if (sortBy === 'coachSkill') {
    return sortTeamsByCoachSkill({ teams })
  }

  if (sortBy === 'coachLeadership') {
    return sortTeamsByCoachLeadership({ teams })
  }

  if (sortBy === 'coachType') {
    return sortTeamsByCoachType({ teams, selectedType: 'D' })
  }

  if (sortBy === 'coachTypeOrder') {
    return sortTeamsByCoachType({ teams, selectedType: coachTypeTop })
  }

  return sortTeamsByTeamId({ teams, direction })
}
